interface Props {
  className?: string
  pathClassName?: string
  FillColor?: string
}

export default function Arrow({
  FillColor = 'black',
  className = '',
  pathClassName = ''
}: Props) {
  return (
    <svg viewBox="0 0 14 12" className={className}>
      <path
        fill={FillColor}
        className={pathClassName}
        d="M8.4715 11.7896C8.38631 11.875 8.24613 11.875 8.16094 11.7896C7.81802 11.4455 7.81802 10.8872 8.16094 10.5432L12.1358 6.55531H0.39076C0.269984 6.55531 0.171855 6.45686 0.170776 6.3346C0.170776 5.84774 0.563299 5.45393 1.04856 5.45393L12.0484 5.45501L8.16094 1.55476C7.81802 1.21071 7.81802 0.65245 8.16094 0.308406C8.24613 0.222935 8.38523 0.221853 8.4715 0.308405L13.5721 5.4258C13.915 5.76985 13.915 6.32811 13.5721 6.67215L8.4715 11.7896Z"
      />
    </svg>
  )
}
